import React from "react";
import { useTranslation } from "react-i18next";
const CellText = ({ data }) => {
  const { i18n } = useTranslation();
  console.log(i18n.language);
  return (
    <>
      <div className="doctor-details-area pt-115 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-xl-4 col-lg-4">
              <img src={"/img/cells/" + data[0].picture} alt="" />
            </div>
            <div className="col-xl-8 col-lg-8">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 ">
                    <div className="appoinment-box white">
                      <div className="appoinment-content">
                        <h2>{data[0].name}</h2>
                        <hr></hr>
                        <p>
                          {i18n.language === "en"
                            ? data[0].detail
                            : data[0].detail_tr}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CellText;
